import { z } from 'zod';
import { idSchema, idempotencyKeySchema } from './common.js';
export const postingAudienceValues = ['internal', 'marketplace'];
export const postingAudienceSchema = z.enum(postingAudienceValues);
export const postingAssignmentModeValues = ['assign', 'claimable'];
export const postingAssignmentModeSchema = z.enum(postingAssignmentModeValues);
export const postingStatusValues = [
    'open',
    'claimed',
    'cancelled',
    'completed',
];
export const postingStatusSchema = z.enum(postingStatusValues);
// -------- Path params --------
export const fleetPostingParamsSchema = z.object({
    fleetId: idSchema,
    postingId: idSchema,
});
// -------- List --------
/**
 * board=true is the driver's claimable board (open, claimable, internal
 * postings the driver can take). mine=true is the driver's own claimed
 * postings. Neither flag = the dispatcher manage view (all of the fleet's
 * postings, newest first), optionally narrowed by status.
 */
export const listPostingsQuerySchema = z.object({
    status: postingStatusSchema.optional(),
    board: z.coerce.boolean().optional(),
    mine: z.coerce.boolean().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
// -------- Create a posting --------
/**
 * One posting advertises one load. audience/assignmentMode default to the
 * internal claimable board. rateAmount is integer pence (phase 2 surfaces it
 * on the driver card); rateVisible controls disclosure.
 */
export const createPostingBodySchema = z
    .object({
    loadId: idSchema,
    audience: postingAudienceSchema.default('internal'),
    assignmentMode: postingAssignmentModeSchema.default('claimable'),
    rateAmount: z.number().int().min(0).max(100_000_000).nullable().optional(),
    rateVisible: z.boolean().optional(),
    notes: z.string().trim().max(4000).nullable().optional(),
})
    .strict();
// -------- Claim a posting --------
/** The claimer is the authenticated user (atomic self-assign); the optional
 *  key makes a double-fired claim an idempotent success (Unit D). */
export const claimPostingBodySchema = z
    .object({ idempotencyKey: idempotencyKeySchema.optional() })
    .strict();
// -------- Cancel a posting --------
export const cancelPostingBodySchema = z
    .object({
    reason: z.string().trim().min(5).max(240).optional(),
})
    .strict();
//# sourceMappingURL=load-postings.js.map